const chat = () =>
    import('./chat/index.vue');
const statistics = () =>
    import('./statistics/index.vue');

export default [
    // 聊天
    {
        path: "/chat",
        name: "chat",
        components: {
            default: chat,
        },
        meta: {
            nav: "chat",
            navChild: "chat",
            navName:"聊天记录",
            keepAlive: true
        },
    },
    {
        path: "/chat/statistics",
        name: "statistics",
        components: {
            default: statistics,
        },
        meta: {
            nav: "chat",
            navChild: "statistics",
            navName:"对话统计",
            keepAlive: true
        },
    },
]



// WEBPACK FOOTER //
// ./src/views/chat/index.js